import { get, post } from './apiService';

const payoutService = {
  getPendingWithdrawals: async () => {
    try {
      return await get('admin/adminWallet/pending-withdrawals', { withCredentials: false });
    } catch (err) {
      throw new Error(err.message || 'Failed to fetch pending withdrawals');
    }
  },
  approveWithdrawal: async (requestId) => {
    try {
      return await post(`admin/adminWallet/approve/${requestId}`, {}, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to approve withdrawal');
    }
  },
  rejectWithdrawal: async (requestId, adminNotes) => {
    try {
      return await post('admin/adminWallet/reject', { requestId, adminNotes }, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to reject withdrawal');
    }
  },
  processPayout: async (requestId) => {
    try {
      return await post(`admin/adminWallet/process-payout/${requestId}`, {}, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to process payout');
    }
  },
};

export default payoutService;
